module.exports = __webpack_public_path__ + "media/packs/images/flags/CY-161e70a50e3c7d7b2e7d0f8ee84464f2.svg";